var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
var defaultAutoScrollOptions = {
    speed: 0.85,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
    stopOnFocusIn: false,
};
function parseJsonAttr(raw, fallback) {
    if (!raw) {
        return fallback;
    }
    try {
        var parsed = JSON.parse(raw.trim());
        return __assign(__assign({}, fallback), parsed);
    }
    catch (_a) {
        return fallback;
    }
}
/**
 * Bilder ändern sonst die Slide-Breite → Resize → Embla reInit → Auto-Scroll fühlt sich an wie Stop/Ruckeln.
 * Einmal nach allen Loads messen, neu initialisieren, Scroll ohne erneutes startDelay fortsetzen.
 */
function stabilizeAutoscrollAfterImages(embla, viewport) {
    var imgs = Array.from(viewport.querySelectorAll('img'));
    if (!imgs.length) {
        return;
    }
    var decodeAndReinit = function () {
        void Promise.all(imgs.map(function (img) {
            return typeof img.decode === 'function'
                ? img.decode().catch(function () { return undefined; })
                : Promise.resolve();
        })).then(function () {
            var _a;
            embla.reInit();
            (_a = embla.plugins().autoScroll) === null || _a === void 0 ? void 0 : _a.play(0);
        });
    };
    var afterLoads = function () {
        var pending = imgs.filter(function (img) { return !img.complete; });
        if (pending.length === 0) {
            decodeAndReinit();
            return;
        }
        void Promise.all(pending.map(function (img) {
            return new Promise(function (resolve) {
                img.addEventListener('load', function () { return resolve(); }, { once: true });
                img.addEventListener('error', function () { return resolve(); }, { once: true });
            });
        })).then(decodeAndReinit);
    };
    embla.on('init', function onCowpEmblaInit() {
        embla.off('init', onCowpEmblaInit);
        afterLoads();
    });
}
/**
 * Initialisiert alle Viewports mit `data-cowp-embla` (z. B. im Hero).
 * `data-cowp-embla="auto-scroll"` → Embla + Auto-Scroll-Plugin.
 *
 * Markup: Viewport `.cowp-embla` mit Kind `.cowp-embla__container` und
 * `.cowp-embla__slide` (siehe Embla „Required Setup“).
 */
export function initCowpEmblaCarousels(root) {
    if (root === void 0) { root = document; }
    var apis = [];
    root.querySelectorAll('[data-cowp-embla]').forEach(function (viewport) {
        var mode = viewport.getAttribute('data-cowp-embla');
        var emblaOptions = parseJsonAttr(viewport.getAttribute('data-cowp-embla-options'), {
            loop: true,
            align: 'start',
            watchDrag: false,
            dragFree: true,
            skipSnaps: true,
            watchSlides: false,
        });
        var autoScrollOpts = __assign({}, parseJsonAttr(viewport.getAttribute('data-cowp-embla-autoscroll'), __assign({}, defaultAutoScrollOptions)));
        var directionAttr = viewport.getAttribute('data-cowp-embla-autoscroll-direction');
        if (directionAttr === 'forward' || directionAttr === 'backward') {
            autoScrollOpts.direction = directionAttr;
        }
        var plugins = collectPlugins(mode, autoScrollOpts);
        var embla = EmblaCarousel(viewport, emblaOptions, plugins);
        apis.push(embla);
        if (mode === 'auto-scroll') {
            stabilizeAutoscrollAfterImages(embla, viewport);
        }
    });
    return apis;
}
var collectPlugins = function (mode, autoScrollOpts) {
    if (!mode)
        return [];
    switch (mode) {
        case 'auto-scroll':
            return [AutoScroll(autoScrollOpts)];
        default:
            return [];
    }
};
export var cowpEmbla = {
    EmblaCarousel: EmblaCarousel,
    AutoScroll: AutoScroll,
    initCowpEmblaCarousels: initCowpEmblaCarousels,
};
if (typeof window !== 'undefined') {
    window.cowpEmbla = cowpEmbla;
}
